import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=2c581216&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=2c581216&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c581216",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PostponeLogo: require('/Users/grant/Dev/postpone/frontend/components/PostponeLogo.vue').default,PlatformIcon: require('/Users/grant/Dev/postpone/frontend/components/platform/Icon.vue').default,Footer: require('/Users/grant/Dev/postpone/frontend/components/Footer.vue').default})
